import React from "react";
import ReactDOM from "react-dom/client";
import "@cloudscape-design/global-styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import { User } from "./Components/User";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <User>
        <App />
      </User>
    </BrowserRouter>
  </React.StrictMode>
);
